import type { MediaItem } from '@akademi/site-builder-runtime';
import { ContentRail } from '../ui/ContentRail';
import { VideoCard } from './VideoCard';

/**
 * Horizontal rail of {@link VideoCard}s. Used by detail pages
 * (related rail, episodes rail) and other compositions.
 */
export interface VideoRailProps {
  title?: string;
  items: MediaItem[];
  variant?: 'youtube' | 'minimal' | 'poster' | 'cinematic';
  videoHrefTemplate?: string;
  activeSlug?: string;
}

export function VideoRail({
  title,
  items,
  variant = 'youtube',
  videoHrefTemplate,
  activeSlug,
}: VideoRailProps) {
  return (
    <section style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {title && (
        <h3 style={{ margin: 0, fontSize: 'var(--font-size-md, 16px)', fontWeight: 600 }}>
          {title}
        </h3>
      )}
      <ContentRail ariaLabel={title || 'Videos'} itemWidth="280px" snap="start">
        {items.map((item) => (
          <VideoCard
            key={item.id}
            item={item}
            variant={variant}
            {...(videoHrefTemplate ? { hrefTemplate: videoHrefTemplate } : {})}
            active={activeSlug === item.slug}
          />
        ))}
      </ContentRail>
    </section>
  );
}
